<template>
    <div class="wb-title">{{ title }}</div>
</template>
<script>
export default {
    name: 'wbTitle',
    props: {
        title: {
            type: String,
            default: '标题'
        }
    }
}
</script>
<style lang="scss" scoped>
.wb-title {
    width: 100%;
    height: 39px;
    line-height: 39px;
    font-size: 16px;
    padding-left: 12px;
    border-bottom: 1px solid rgba(96, 98, 102, 0.1412);
}
</style>